import React, { memo, useContext, useEffect } from 'react'
import { MountContext } from './Mount'
import { incrementOverflowCount, decrementOverflowCount } from '../utils/overflowManager'

import '../styles/modal.scss'

function Modal({ children }) {
  const mount = useContext(MountContext)

  useEffect(() => {
    incrementOverflowCount()
    window.addEventListener('keydown', handleKeydown, true)

    return () => {
      decrementOverflowCount()
      window.removeEventListener('keydown', handleKeydown, true)
    }
  })

  const handleClose = () => {
    mount.pop()
  }

  const handleContentClick = event => {
    event.stopPropagation()
  }

  const handleKeydown = event => {
    if (event.key === 'Escape' || event.keyCode === 27) {
      handleClose()
    }
  }

  return (
    <div className="account-modal" onClick={handleClose}>
      <div className="account-modal__backdrop" />
      <div className="account-modal__layout">
        <div className="account-modal__content" onClick={handleContentClick}>
          <button className="account-modal__close" onClick={handleClose} />
          {children}
        </div>
      </div>
    </div>
  )
}

export default memo(Modal)
